export default __webpack_public_path__ + "static/media/wrapper-bottom.7876a5f9.svg";